import { computed, ref, Ref, watch } from "vue";
import pay from "@/csdPublic/pay";
import login from "@/csdPublic/login";
import useStore from "@/stores/publicStore";
import { getStorage, setStorage } from "@/utils/storage";
import { mobilePayUrl, wxMobilePayUrl } from "@/config/apiDomain";
import qs from "qs";
import { openLoginDialog } from "../loginDialog/login";
import { storeToRefs } from "pinia";
import { customEventReport } from "@/csdPublic/index";

const showMemberDialog: Ref<boolean> = ref(false);
const packageList: Ref<any[]> = ref([]);
const packageIndex: Ref<number> = ref(-1);
const validCode: Ref<boolean> = ref(true);
const payCodeUrl: Ref<string | null> = ref(null);
const packageInfo: any = computed(() => packageList.value[packageIndex.value]);
const packageId: any = computed(
  () => packageList.value[packageIndex.value]?.id
);

const openMemberDialog = async () => {
  const publicStore = useStore();
  const { isLogin } = storeToRefs(publicStore);
  if (!isLogin.value) {
    ElMessage.warning("请先登录");
    openLoginDialog();
    return;
  }
  if (!getStorage("event1")) {
    setStorage("event1", 1);
    customEventReport(1);
  }
  await queryPackageList();
  showMemberDialog.value = true;
};

const closeMemberDialog = () => {
  showMemberDialog.value = false;
  pay.stopInterval();
  setTimeout(() => {
    packageList.value = [];
    packageIndex.value = -1;
  }, 300);
};

const queryPackageList = async () => {
  try {
    const res = await pay.getPackageList();
    packageList.value = res.reverse();
    packageIndex.value = 0;
  } catch (e) {
    console.log(e);
  }
};

const getPayCode = async () => {
  pay.stopInterval();
  try {
    const res = await pay.getPayCode(0, packageId.value);
    const orderId = res.order_id;
    if (res.mobile) {
      mobilePay(res);
      getPayStatus(orderId);
      return;
    }
    payCodeUrl.value = res.url;
    validCode.value = true;
    getPayStatus(orderId);
  } catch (e: any) {
    if (e.code == 403) {
      ElMessage.error("请先登录");
      openLoginDialog();
      return;
    }
    ElMessage.error("获取支付二维码失败");
  }
};

const getPayStatus = async (orderId: number) => {
  const publicStore = useStore();
  const { changeVipInfo } = publicStore;
  try {
    await pay.payPoll(orderId);
    ElMessage.success("支付成功");
    closeMemberDialog();
  } catch (e) {
    validCode.value = false;
  } finally {
    changeVipInfo();
  }
};

const mobilePay = (data: any) => {
  let query = {
    soft_id: getStorage("soft_id"),
    ekey: getStorage("ekey"),
    source: getStorage("source"),
  };
  setStorage("isPay", JSON.stringify({ orderId: data.id }));
  if (login.isWeiXinEnv()) {
    window.location.href = `${wxMobilePayUrl}/api/show-order?order_id=${
      data.id
    }&${qs.stringify(query)}`;
    return;
  }
  window.location.href = `${mobilePayUrl}/pay/pay.html?order_id=${
    data.id
  }&skip=order&${qs.stringify(query)}`;
};

watch(packageId, () => {
  if (packageId.value) getPayCode();
});

export {
  showMemberDialog,
  packageList,
  packageIndex,
  payCodeUrl,
  packageInfo,
  validCode,
  getPayCode,
  openMemberDialog,
  closeMemberDialog,
};
